import React, { useState, useEffect } from 'react';
import ExecuteAxios from "../../../Components/ExecuteAxios/ExecuteAxios";
import LoadingIndicator from 'Components/LoadingIndicator/LoadingIndicator';
import Panel from 'Components/Panel/Panel';

const UserCalendarMonth = ({
    sectorSelected,
    managerSelected,
    employeeSelected,
    resetFilterDay,
    selectedActualDate
}) => {
    const [scheduleActualMonth, setScheduleActualMonth] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                let currentDateOfMonth;
                if (selectedActualDate) {
                    currentDateOfMonth = new Date(selectedActualDate).toISOString().split('T')[0];
                }

                const daysScheduled = await getScheduledDays(currentDateOfMonth);
                setScheduleActualMonth(await getCalendarDays(selectedActualDate, daysScheduled));
            } catch (error) {
                console.error('Error to search scheduled days (selectedActualDate):', error);
            }
        };

        fetchData();
    }, [sectorSelected, managerSelected, employeeSelected, resetFilterDay, selectedActualDate]);

    const getDayNames = () => {
        const weekdays = ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'];
        return weekdays.map((day, index) => (
            <div key={index} className="calendar-day-name">
                {day}
            </div>
        ));
    };

    async function getScheduledDays(currentDateOfMonth) {
        if (sectorSelected) {
            const parameters = {
                sectorId: sectorSelected,
                managerId: managerSelected,
                employeeId: employeeSelected,
                monthYear: currentDateOfMonth
            };
            return await ExecuteAxios.api('get', `/employee-hours-available/color-employee-days-available/`, { params: parameters });
        } else {
            return [];
        }
    }

    const getCalendarDays = async (startDate, daysScheduled) => {
        if (!startDate) {
            return
        }

        const firstDayOfMonth = new Date(startDate.getFullYear(), startDate.getMonth(), 1);
        const lastDayOfMonth = new Date(startDate.getFullYear(), startDate.getMonth() + 1, 0);
        const daysInMonth = lastDayOfMonth.getDate();
        const startOffset = firstDayOfMonth.getDay();
        const totalDays = startOffset + daysInMonth;
        const weeksInMonth = Math.ceil(totalDays / 7);
        const calendarDays = [];

        for (let week = 0; week < weeksInMonth; week++) {
            for (let dayOfWeek = 0; dayOfWeek < 7; dayOfWeek++) {
                const dayIndex = week * 7 + dayOfWeek;
                if (dayIndex >= startOffset && dayIndex < startOffset + daysInMonth) {
                    const currentDayOfMonth = dayIndex - startOffset + 1;

                    const currentDate = new Date(startDate.getFullYear(), startDate.getMonth(), currentDayOfMonth);
                    const currentDateOfMonth = currentDate.toISOString().split('T')[0];

                    const backgroundColor = getColorUsersScheduled(currentDate, daysScheduled)
                    let textColor = currentDateOfMonth === selectedActualDate ? 'red' : 'inherit';

                    calendarDays.push(
                        <div
                            key={currentDateOfMonth}
                            className={!!backgroundColor ? 'calendar-day scheduled-day' : 'calendar-day'}
                            style={{ color: textColor, backgroundColor: backgroundColor }}
                            data-tip={currentDateOfMonth}
                        >
                            {currentDayOfMonth}
                        </div>
                    );
                } else {
                    if (dayIndex < 32)
                        calendarDays.push(<div key={dayIndex} className="calendar-day empty-day">0</div>);
                }
            }
        }
        calendarDays.push(<div key={32} className="calendar-day empty-day">32</div>);
        calendarDays.push(<div key={33} className="calendar-day empty-day">33</div>);
        calendarDays.push(<div key={34} className="calendar-day empty-day">34</div>);
        calendarDays.push(<div key={35} className="calendar-day empty-day">35</div>);
        calendarDays.push(<div key={36} className="calendar-day empty-day">36</div>);
        return calendarDays;
    };

    function getColorUsersScheduled(scheduleDay, daysScheduled) {
        if (!daysScheduled || daysScheduled.length === 0) {
            return null;
        }

        const options = { day: '2-digit', month: '2-digit', year: 'numeric' };
        const formatPtBr = new Intl.DateTimeFormat('pt-BR', options);
        let formattedScheduleDay;
        if (scheduleDay) {
            formattedScheduleDay = formatPtBr.format(scheduleDay);
        }

        if (formattedScheduleDay) {
            const formattedDay = new Date(formattedScheduleDay.split('/').reverse().join('-')).toISOString().split('T')[0];
            const value = daysScheduled[formattedDay];

            return value ? value : 'red'
        } else {
            return false;
        }
    }

    const calendarContainer = {
        display: 'flex',
        backgroundColor: '#f5f5f5',
        height: '100%'
    }

    return (
        <>
            <Panel style={calendarContainer}>
                <div id='calendars'>
                    <div>
                        <div className="calendar-header">
                            <span className='name-month'>{!selectedActualDate ? null : selectedActualDate.toLocaleString('default', { month: 'long', year: 'numeric' })}</span>
                        </div>
                        <LoadingIndicator loaded={scheduleActualMonth}>
                            <div className="calendar">
                                <div className="grid-template-columns">
                                    {getDayNames()}
                                    {scheduleActualMonth}
                                </div>
                            </div>
                        </LoadingIndicator>

                    </div>
                </div>
            </Panel>
        </>
    );
};

export default UserCalendarMonth;


